import React, { useMemo } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ListSidebar, MainLayout } from "layouts";
import { HomePage } from "./HomePage";
import { SystemLogsPage } from "./SystemLogsPage";
import { McpLibraryPage } from "./McpLibraryPage";
import { Error404Page } from "pages/Error404Page";
import { Link } from "components";
import { clsx } from "@ismael1361/utils";
import { Divider } from "@mui/material";
import Icon from "@mdi/react";
import { mdiViewDashboard, mdiAccountCog, mdiConsole, mdiScriptTextOutline, mdiPuzzleOutline, mdiCurrencyUsd, mdiLifebuoy, mdiLogout } from "@mdi/js";
import { UserServices } from "shared/services";
import { getVersion } from "shared/utils";

import styles from "./styles.module.scss";

interface MenuItemProps {
	icon: string;
	label: string;
	path: string;
	disabled?: boolean;
	isActive?: () => boolean;
	onClick?: () => void;
	color?: string;
}

const menuItems: Array<MenuItemProps> = [
	{
		icon: mdiViewDashboard,
		label: "Dashboard",
		path: "/backoffice",
		isActive: () => /^\/backoffice\/?$/gi.test(window.location.pathname),
	},
	{
		icon: mdiScriptTextOutline,
		label: "Logs do Sistema",
		path: "/backoffice/system-logs",
		isActive: () => /^\/backoffice\/system-logs/gi.test(window.location.pathname),
	},
	{
		icon: mdiPuzzleOutline,
		label: "Biblioteca de MCPs",
		path: "/backoffice/mcp-library",
		isActive: () => /^\/backoffice\/mcp-library/gi.test(window.location.pathname),
	},
	{ icon: mdiAccountCog, label: "Gestão de Clientes", path: "/backoffice/clients", disabled: true },
	{ icon: mdiConsole, label: "Execução de Scripts", path: "/backoffice/scripts", disabled: true },
	{ icon: mdiCurrencyUsd, label: "Faturamento Global", path: "/backoffice/billing", disabled: true },
	{ icon: mdiLifebuoy, label: "Suporte Técnico", path: "/backoffice/support", disabled: true },
];

const MenuItem: React.FC<MenuItemProps> = ({ icon, label, path, disabled, isActive, onClick, color }) => {
	const location = useLocation();
	return useMemo(
		() => (
			<Link
				href={path}
				disabled={disabled}
				onClick={
					onClick
						? (e) => {
								e.preventDefault();
								onClick();
							}
						: undefined
				}
				className={clsx(styles.navItem, isActive?.() && styles.active)}
				style={{ "--color": color } as React.CSSProperties}
			>
				<div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
					<Icon
						path={icon}
						size={1}
					/>
					{label}
				</div>
			</Link>
		),
		[location.pathname, disabled],
	);
};

export const BackofficePage: React.FC = () => {
	return (
		<MainLayout
			sidebar={
				<ListSidebar>
					<aside className={styles.sidebar}>
						<div className={styles.sidebarTitle}>Backoffice</div>
						<nav className={styles.nav}>
							{menuItems.map((item, index) => (
								<MenuItem
									key={index}
									{...item}
								/>
							))}
							<Divider />
							<MenuItem
								icon={mdiLogout}
								label="Desconectar Conta"
								path="/"
								onClick={() => {
									UserServices.signOut(true);
								}}
								color="var(--mui-palette-error-main)"
							/>
							<div
								style={{
									height: "auto",
									width: "100%",
									flex: 1,
								}}
							/>
							<div className={styles.versionInfo}>VERSÃO: {getVersion()}</div>
						</nav>
					</aside>
				</ListSidebar>
			}
		>
			<div className={styles.contentContainer}>
				<div className={styles.mainContent}>
					<Routes>
						<Route
							path="/"
							element={<HomePage />}
						/>
						<Route
							path="/system-logs"
							element={<SystemLogsPage />}
						/>
						<Route
							path="/mcp-library"
							element={<McpLibraryPage />}
						/>
						<Route
							path="*"
							element={<Error404Page />}
						/>
					</Routes>
				</div>
			</div>
		</MainLayout>
	);
};
